import React from 'react'
import PropTypes from 'prop-types'
import {Box, Flex, SimpleGrid, useBreakpointValue, useMultiStyleConfig} from '@chakra-ui/react'
import {MenuCard} from './menu-card'
import {getGlobalLink} from '../../utils/contentstack-utils'

const MenuCardGroup = ({group, categoriesData, type, onItemClick, extraCard}) => {
    const styles = useMultiStyleConfig('KenwoodMenu')

    const isPromo = type === 'promo' || type === 'firstLevelPromo'
    const isFilter = type === 'filter'

    let columns = useBreakpointValue({
        base: {default: '2', filter: '1', promo: '1'},
        md: {default: '4', filter: '2', promo: '2'},
        lg: {default: '4', filter: '1', promo: '3'},
    })

    let cards = group?.cards
    const shouldLastElementBeFullWidth = useBreakpointValue({
        base: cards?.length % 2 === 1 && !isPromo && !isFilter ? true : false,
        md: false,
    })

    let numColumns = isFilter ? columns.filter : isPromo ? columns.promo : columns.default

    let lastCard = shouldLastElementBeFullWidth ? cards?.[cards?.length - 1] : null
    if (isPromo) {
        cards = cards?.slice(0, 6)
    } else if (isFilter) {
        cards = cards?.slice(0, 2)
    } else {
        cards = cards?.slice(0, 8)
        cards = shouldLastElementBeFullWidth ? cards?.slice(0, -1) : cards
    }

    let lastCardContent = null
    if (lastCard) {
        const {url, label, isAbsolute} = getGlobalLink({link: lastCard?.redirects, categoriesData})
        const variant =
            lastCard?._content_type_uid === 'kenwood_menusecondarycard' ? 'defaultLarge' : 'default'
        lastCardContent = (
            <MenuCard
                key={lastCard.uid}
                title={label ?? lastCard?.link?.title}
                url={url ?? lastCard?.link?.href}
                subtitle={lastCard?.subtitle}
                secondaryTitle={lastCard?.secondaryTitle}
                image={lastCard?.image}
                isLink
                isAbsolute={isAbsolute}
                variant={variant}
                handleClick={onItemClick}
                fullWidth
            />
        )
    }

    const content = cards?.map((card) => {
        const {url, label, isAbsolute} = getGlobalLink({link: card?.redirects, categoriesData})

        const variant = isFilter
            ? 'filter'
            : isPromo
            ? 'promo'
            : card?._content_type_uid === 'kenwood_menusecondarycard'
            ? 'defaultLarge'
            : 'default'
        return (
            <MenuCard
                key={card.uid}
                title={label ?? card?.link?.title}
                url={url ?? card?.link?.href}
                subtitle={card?.top_label || card?.subtitle}
                secondaryTitle={card?.label || card?.secondaryTitle}
                image={card?.image}
                isLink
                isAbsolute={isAbsolute}
                variant={variant}
                handleClick={onItemClick}
            />
        )
    })
    if (isPromo || isFilter) {
        return (
            <Box pos="relative">
                <SimpleGrid columns={numColumns} {...styles.cardGroupContainer}>
                    {content}
                </SimpleGrid>
            </Box>
        )
    }

    return (
        <Box pos="relative">
            <Flex {...styles.cardGroupContainerFlex}>
                {content} {extraCard && extraCard}
            </Flex>

            {lastCardContent}
        </Box>
    )
}

MenuCardGroup.propTypes = {
    group: PropTypes.object,
    categoriesData: PropTypes.object,
    type: PropTypes.string,
    compact: PropTypes.bool,
    onItemClick: PropTypes.func,
    extraCard: PropTypes.element,
}

export {MenuCardGroup}
